export default __webpack_public_path__ + "static/media/logo_gcomm_white.81d2423c.png";